


























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { STATUSES as SERVICE_REQUEST_STATUSES } from '@/constants/service_request';
import { mapState } from 'vuex';
import _ from 'lodash';

@Component({
  computed: {
    ...mapState('Auth', {
      business: 'activeBusiness',
    }),
    ...mapState('ServiceRequest', {
      activeServiceRequest: 'activeServiceRequest',
    }),
  },
})
export default class ServiceRequestReadServiceCandidate extends Vue {
  @Prop() serviceItems!: Model[];

  activeServiceRequest!: Model;
  business!: Model;

  isMounted = false;
  isLoading = false;

  canSubmit = false;

  serviceRequestStatues = SERVICE_REQUEST_STATUSES;

  get bookingCandidates() {
    return this.activeServiceRequest._booking_candidates || [];
  }

  get headers() {
    const headers = [
      {
        text: 'Candidate',
        value: 'candidate',
        align: 'start',
      },
    ];
    for (let i = 0; i < this.filteredServiceItems.length; i++) {
      headers.push({
        align: 'center',
        text: this.filteredServiceItems[i].name ?? '',
        value: 'service_request',
      });
    }
    headers.push({
      align: 'center',
      text: 'Action',
      value: 'booking',
    });
    return headers;
  }

  get filteredServiceItems() {
    const serviceCandidates = _.map(
      this.bookingCandidates,
      '_filtered_service_candidates'
    ).flat();
    return this.serviceItems.filter(
      (item) =>
        !_.isEmpty(
          serviceCandidates.find(
            (candidate) => candidate.service_item.object_id === item.object_id
          )
        )
    );
  }

  filterCandidate(value, search, item) {
    return Object.keys(item).some((k) => {
      return (
        [
          'first_name',
          'last_name',
          'date_of_birth',
          'mobile',
          'email',
        ].includes(k) &&
        item[k]
          .toString()
          .toLowerCase()
          .includes(search)
      );
    });
  }

  name(item) {
    if (!item.first_name && !item.last_name) {
      return null;
    }
    return (item.first_name ?? '') + ' ' + (item.last_name ?? '');
  }

  isRequested(serviceCandidates, serviceItemOid) {
    if (_.isEmpty(serviceCandidates)) {
      return false;
    }

    const serviceCandidate = serviceCandidates.find(
      (item) => item.service_item.object_id === serviceItemOid
    );
    if (serviceCandidate) {
      return true;
    } else {
      return false;
    }
  }

  toRead(oid) {
    if (
      this.$route.name == 'business-booking-read' &&
      this.$route.params.bookingOid &&
      this.$route.params.bookingOid == oid
    ) {
      this.$emit('closeDialog');
    } else {
      this.$router.push({
        name: 'business-booking-read',
        params: {
          bookingOid: oid,
        },
      });
    }
  }
}
